<script>
    import { navigating, page } from '$app/stores';
    import { auth } from '$lib/auth';
    import { cartContents, theCart } from '$stores/cart';
    import CheckoutSteps from '$components/CheckoutSteps.svelte';
    import { browser } from '$app/environment';
    import { onMount, onDestroy } from 'svelte';
    import 'animate.css';
	import { prizes } from '$stores/prizes';
	import { isAppUser } from '$stores/isAppUser';

    $: hasLegoPrizes = $prizes.some(
        (p) =>
            (typeof p.category === 'string' && p.category.includes('lego')) ||
            (Array.isArray(p.categories) && p.categories.includes('lego'))
    );
    $: hasPokemonPrizes = $prizes.some(
        (p) =>
            (typeof p.category === 'string' && p.category.includes('pokemon')) ||
            (Array.isArray(p.categories) && p.categories.includes('pokemon'))
    );

    // Define your navigation items with optional submenus
    const navItems = [
        { title: 'Home', href: '/' },
        { title: 'About', href: '/about',
            submenu: [
                ...(!$isAppUser ? [{ title: 'Subscribe & Save', href: '/subscribe' }] : []),
                { title: 'How it works', href: '/about' },
            ]
         },
        { 
            title: 'Prizes', 
            href: '/prizes',
            submenu: [
				{ title: "Instant Wins", href: "/prizes?filters=instant+wins" },
                { title: "Lego Prizes", href: "/prizes/category/lego" },
                { title: "Pokemon Prizes", href: "/prizes/category/pokemon" },
                { title: "All Prizes", href: "/prizes" },
                // { title: "Ending Soon", href: "/prizes/ending-soon" },
                // { title: "New Competitions", href: "/prizes/new" },
                // { title: "Last Chance", href: "/prizes/last-chance" },
            ]
        },
        { title: 'Winners', href: '/winners' },
        // { title: 'Subscribe & Save', href: '/subscribe' },
        // { 
        //     title: 'More', 
        //     href: '/more',
        //     submenu: [
        //         { title: 'Blog', href: '/blog' },
        //         { title: 'Careers', href: '/careers' },
        //     ]
        // },
        // Add more items as needed
    ];

    // Existing state variables...
    let open = false;
    let search = false;
    let showCheckoutSteps = false;
    let currentStepIndex = 0;
    let ticketImgDesktop;
    let ticketImgMobile;

    $: pagePathname = $page.url.pathname;
    $: usersName = $auth?.user?.displayName;

    function updateCheckoutStep() {
        if (!browser) return;

        const URL = $navigating?.to?.url || $page.url;
        if (URL?.pathname?.includes('/checkout')) {
            if (URL.pathname.includes('/step-three') || URL.pathname.includes('/confirming')) {
                showCheckoutSteps = false;
                return;
            }
            showCheckoutSteps = true;
            const urlStep = URL?.pathname?.replace('/checkout/step-', '');

            switch (urlStep) {
                case 'one':
                    currentStepIndex = 0;
                    break;
                case 'two':
                    currentStepIndex = 1;
                    break;
                case 'three':
                    currentStepIndex = 2;
                    break;
                default:
                    currentStepIndex = 0;
            }
        } else {
            showCheckoutSteps = false;
        }
    }

    // Dropdown state management
    let activeDropdown = null; // Tracks the currently active dropdown on desktop
    let activeAccordion = {}; // Tracks active accordions on mobile

    // Determine if the viewport is mobile
    let isMobile = false;

    function checkIsMobile() {
        if (browser) {
            isMobile = window.innerWidth < 870;
        }
    }

    function toggleDropdown(index) {
        if (!isMobile) {
            activeDropdown = activeDropdown === index ? null : index;
        }
    }

    function toggleAccordion(index) {
        if (isMobile) {
            activeAccordion = { 
                ...activeAccordion, 
                [index]: !activeAccordion[index] 
            };
        }
    }

    // Close dropdowns when clicking outside
    function handleClickOutside(event) {
        const nav = document.querySelector('nav');
        if (nav && !nav.contains(event.target)) {
            activeDropdown = null;
        }
    }

    let resizeListener;
    let cartSubscription;
    $: authSubscription = $auth.user;

    onMount(() => {
        if (!browser) return;

        // Initial checks
        checkIsMobile();
        updateCheckoutStep();

        // Subscribe to cart changes for animations
        cartSubscription = theCart.subscribe(() => {
            if (ticketImgDesktop && ticketImgMobile) {
                ticketImgDesktop?.classList.add('shakeitlikeits-hot');
                ticketImgMobile?.classList.add('shakeitlikeits-hot');

                setTimeout(() => {
                    ticketImgDesktop?.classList.remove('shakeitlikeits-hot');
                    ticketImgMobile?.classList.remove('shakeitlikeits-hot');
                }, 1000);
            }
        });

        // Handle window resize
        resizeListener = () => {
            const wasMobile = isMobile;
            checkIsMobile();
            if (wasMobile !== isMobile) {
                // Reset dropdown and accordion states when switching between mobile and desktop
                activeDropdown = null;
                activeAccordion = {};
            }
        };
        window.addEventListener('resize', resizeListener);

        // Handle clicks outside navigation
        document.addEventListener('click', handleClickOutside);



        return () => {
            // Cleanup subscriptions and event listeners
            if (cartSubscription) cartSubscription();
            // if (authSubscription) authSubscription();
            window.removeEventListener('resize', resizeListener);
            document.removeEventListener('click', handleClickOutside);
        };
    });

    // Update checkout steps on navigation
    $: if ($navigating) updateCheckoutStep();
</script>



<header>
    <div class="container-no-pad flex">
        <a href="/" target="_self" class="logo logo--page-header desktop-logo">
            <img src="/logo-wide.jpeg" alt="HotDraw UK" />
        </a>

        <div class="flex">
            <div class="mobile-cart">
                <a
                    class="logo logo--page-header mobile-logo"
                    href="/"
                    target="_self"
                >
                    <img src="/logo-full.png" alt="HotDraw UK" />
                </a>

                <div class="mob-menu--right">
                    {#if !$page.url.pathname.includes('/checkout')}
                        <a
                            class="ticket-cart"
                            target="_self"
                            href="/cart"
                            on:click={() => {
                                open = false;
                                search = false;
                            }}
                        >
                            <img
                                src="/images/ticket.png"
                                alt="Ticket collection"
                                class="ticket-img"
                                bind:this={ticketImgMobile}
                            />
                            <span class="count">{$cartContents.length || 0}</span>
                        </a>
                    {/if}

                    {#if !$page.url.pathname.includes('/checkout')}
                        <button
                            class="nav-btn"
                            on:click|preventDefault={() => {
                                open = !open;
                                search = false;
                            }}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                            <p>Menu</p>
                        </button>
                    {/if}

                    {#if $page.url.pathname.includes('/checkout')}
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
                                <path
                                    d="M16 3c-3.844 0-7 3.156-7 7v3H6v16h20V13h-3v-3c0-3.844-3.156-7-7-7Zm0 2c2.754 0 5 2.246 5 5v3H11v-3c0-2.754 2.246-5 5-5ZM8 15h16v12H8Z"
                                />
                            </svg>
                        </div>
                    {/if}
                </div>
            </div>
        </div>

        <nav
            class={open ? 'nav nav--page-header active' : 'nav nav--page-header'}
            
        >
            <ul class="no-format">
                {#each navItems as item, index}
                    <li
                        class:active={$page.url.pathname === item.href}
                        class:has-submenu={!!item.submenu}
                        on:mouseenter={() => toggleDropdown(index)}
                        on:mouseleave={() => toggleDropdown(null)}
                    >
                        {#if item.submenu}
                            <!-- Parent Link with Submenu -->
                            <a
                                href={item.href}
                                target="_self"
                                class="has-submenu"
                                aria-haspopup="true"
                                aria-expanded={activeDropdown === index ? 'true' : 'false'}
                                on:click|preventDefault={() => {
                                    toggleAccordion(index);
                                }}
                            >
                                {item.title}
                                {#if isMobile}
								<div class="dropdown-arrow" class:active={activeAccordion[index]}>
                                    <svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">

                                        <rect x="0" fill="none" width="24" height="24"/>
                                        
                                        <g>
                                        
                                        <path d="M20 9l-8 8-8-8 1.414-1.414L12 14.172l6.586-6.586"/>
                                        
                                        </g>
                                        
                                    </svg>
                                </div>
								{/if}
                            </a>
                            <!-- Submenu -->
                            <ul
                                class={
                                    !isMobile
                                        ? 'dropdown-menu ' + (activeDropdown === index ? 'show' : '')
                                        : 'accordion-menu ' + (activeAccordion[index] ? 'open' : '')
                                }
                                aria-label={`${item.title} submenu`}
                            >
                                {#each item.submenu as subitem}
                                    <li class:active={$page.url.pathname === subitem.href}>
                                        <a href={subitem.href} target="_self">
                                            {subitem.title}
                                        </a>
                                    </li>
                                {/each}
                            </ul>
                        {:else}
                            <a href={item.href} target="_self">{item.title}</a>
                        {/if}
                    </li>
                {/each}

                {#if $cartContents.length > 0}
                    <li class:active={$page.url.pathname === '/checkout'}>
                        <a target="_self" href="/checkout/step-one">Checkout</a>
                    </li>
                {/if}

                <li class="cart-item">
                    <a target="_self" class="ticket-cart" href="/cart">
                        <img
                            src="/images/ticket.png"
                            alt="Ticket collection"
                            class="ticket-img"
                            bind:this={ticketImgDesktop}
                        />
                        <span class="count">{$cartContents.length || 0}</span>
                        {#if $theCart?.printTotal}
                            {#if parseFloat($theCart?.totalAmountSaved) > 0}
                                <span>
                                    <sup><strike>£{$theCart?.originalTotal.toFixed(2)}</strike></sup>
                                    <br />
                                    <sup class="red">£{$theCart?.printTotal.toFixed(2)}</sup>
                                </span>
                            {:else}
                                <span>
                                    <sup>£{$theCart?.printTotal.toFixed(2)}</sup>
                                </span>
                            {/if}
                        {/if}
                    </a>
                </li>

                {#if $auth?.user}
                    {#if $auth.user && $auth.user.email}
                        <li class="mobile-account has-submenu"
                        on:mouseenter={() => toggleDropdown(10)}
                        on:mouseleave={() => toggleDropdown(null)}>
                            <a 
                            target="_self" 
                            class="has-submenu" 
                            href="/account"
                            aria-haspopup="true"
                            aria-expanded={activeDropdown === 10 || $page.url.pathname === '/account' ? 'true' : 'false'}
                            on:click|preventDefault={() => {
                                toggleAccordion(10);
                            }}><span>Account</span>
                            
                                {#if isMobile}
                                <div class="dropdown-arrow" class:active={activeAccordion[10]}>
                                    <svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    
                                        <rect x="0" fill="none" width="24" height="24"/>
                                        
                                        <g>
                                        
                                        <path d="M20 9l-8 8-8-8 1.414-1.414L12 14.172l6.586-6.586"/>
                                        
                                        </g>
                                        
                                    </svg>
                                </div>
                                {/if}
                            </a>
                             <!-- Submenu -->
                             <ul
                                class={
                                    !isMobile
                                        ? 'dropdown-menu ' + (activeDropdown === 10 ? 'show' : '')
                                        : 'accordion-menu ' + (activeAccordion[10] ? 'open' : '')
                                }
                                aria-label={`account submenu`}
                            >
                                <li class:active={$page.url.pathname === '/account'}>
                                    <a href='/account' target="_self" class:active={$page.url.pathname === '/account'}>
                                        Dashboard
                                    </a>
                                </li>
                                {#if !$isAppUser}
                                <li class:active={$page.url.pathname === '/subscribe'}>
                                    <a href='/subscribe' target="_self" class:active={$page.url.pathname === '/subscribe'}>
                                        Subscriptions
                                    </a>
                                </li>
                                {/if}
                                <li class:active={$page.url.pathname === '/account/referrals'}>
                                    <a href='/account/referrals' target="_self" class:active={$page.url.pathname === '/account/referrals'}>
                                        Refer & Earn
                                    </a>
                                </li>
                                
                            </ul>
                        </li>
                        <!-- <li class="users-name">
                            {#if usersName}
                                <p>Hi, {usersName.split(' ')[0]}</p>
                            {/if}
                            <br />
                            <sup>({$auth.user.email})</sup>
                        </li> -->
                    {:else}
                        <li class:active={$page.url.pathname === '/login'}>
                            <a target="_self" href="/login">Log in</a>
                        </li>
                        <li class:active={$page.url.pathname === '/register'}>
                            <a target="_self" href="/register">Register</a>
                        </li>
                    {/if}
                {:else}
                    <li class:active={$page.url.pathname === '/login'}>
                        <a target="_self" href="/login">Log in</a>
                    </li>
                    <li class:active={$page.url.pathname === '/register'}>
                        <a target="_self" href="/register">Register</a>
                    </li>
                {/if}
            </ul>
        </nav>
    </div>
</header>

{#if showCheckoutSteps && $cartContents.length > 0}
    <CheckoutSteps {currentStepIndex} />
{/if}

<style lang="scss">
    .cart-item {
    }

    .users-name {
        p {
            font-weight: 400;
            font-size: 1rem;
            margin: 0;
        }
    }

    .mob-menu--right {
        white-space: nowrap;
        > a,
        button {
            display: inline-block;
            vertical-align: middle;
        }
    }
    header {
        background-color: white;
        position: sticky;
        top: 0;
        z-index: 999;
        box-shadow: 0px 10px 15px rgba(155, 155, 155, 70%);
    }

    .container-no-pad {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    sup {
        font-size: 14px;
    }

    .nav ul {
        justify-content: space-between;
        align-items: center;
        text-align: right;

        li {
            text-align: center;
            border-bottom: 1px solid #f3f3f3;
			
            a,
            button {
				padding: 10px 20px;
                font-weight: 600;
                font-size: 16px;
                letter-spacing: 0.05em;
                text-decoration: none;
                display: flex;
                align-items: center;
                text-align: center;
                color: #131314;
                transition: ease all 0.2s;
            }

            a:hover {
                color: #fe1100;
            }

            button {
                appearance: none;
                border: none;
            }

            // &.active {
            //     a {
            //         color: #fe1100;
            //     }
            // }

            &.has-submenu {
                position: relative;
				border: none !important;
            }
        }
    }

	.has-submenu + ul {
		list-style-type: none;
		padding: 0;
		margin: 0;
		li {
			padding: 0;
		}
	}

    .count {
        color: #fe1100;
        display: inline-block;
        border-radius: 0.8em;
        text-align: center;
        padding: 0.2em 0.5em;
        font-size: 12px;
    }

    .logo:not(.desktop-logo) {
        max-width: 45px;
        padding: 5px 0;
        margin: 0;
    }
    .desktop-logo {
        max-width: 140px;
        // padding: 5px;
    }

    .nav-btn {
        position: relative;
        display: block;
        appearance: none;
        border: none;
        background-color: white;
        margin: 5px;
		outline: none;

		&:focus {
			outline: none;
		}

		p {
			font-weight: 600;
			font-size: 0.85em;
			color: #131314;
			margin: 0;
		}

        span {
            width: 30px;
            display: block;
            height: 4px;
            margin: 4px auto;
            border-radius: 4px;
            background-color: #fe1100;
        }
    }


    .mobile-cart {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        min-height: 58px;
        padding: 0 10px;
        padding-right: 0;

        > div {
            white-space: nowrap;
            svg,
            p {
                display: inline-block;
                vertical-align: top;
            }
        }

        button,
        a:not(.logo) {
            min-width: 50px;
            text-align: center;
            text-decoration: none;
        }

        p {
            margin: 0;
            font-weight: 700;
            font-size: 0.85em;
        }

        span.count {
            padding: 0.2em 0;
            font-weight: 700;
        }

        button {
            margin: 0;
        }
    }

    .desktop-logo {
        display: none;
    }

    @media only screen and (min-width: 869px) {
        .nav-btn {
            display: none;
        }
        .container-no-pad {
            flex-wrap: nowrap;
            flex-direction: row;
            align-items: center;
        }

        nav ul {
            display: flex;

            li {
                border-bottom: none !important;
                // border-left: 1px solid #f3f3f3;

                sup {
                    top: 0;
                }
            }
        }

        .mobile-cart {
            display: none;
        }

        .desktop-logo {
            display: block;
        }

        .mobile-account .dropdown-menu {
            left: auto;
            right: 0;
        }
    }

    .ticket-cart {
        img {
            width: 30px;
            height: 30px;
        }

        sup {
            display: block;
        }
    }

    a.active {
        color: #fe1100 !important;
    }

    @media only screen and (max-width: 869px) {
        .nav {
            flex-basis: 100%;
            display: none;
            padding-bottom: 40px;

            &.active {
                display: block;
            }
            ul li {
                padding: 5px 0;
				a {
					padding-left: 15px;
					padding-right: 15px;
				}
            }
            ul li sup {
                position: relative;
                padding-top: 10px;
            }
        }

        .container-no-pad {
            display: block;
            .flex {
                display: block;
            }
        }

        /* Hide desktop dropdowns on mobile */
        .dropdown-menu.show {
            display: none;
        }

        /* Accordion-specific styles */
        .accordion-menu {
            display: none;
            flex-direction: column;
        }

        .accordion-menu.open {
            display: flex;
        }

        .accordion-menu li {
            padding: 10px 20px;
            // border-top: 1px solid #f3f3f3;
        }

        .accordion-menu li a {
            color: #131314;
            text-decoration: none;
            display: block;
            padding: 8px 0;
        }

        .accordion-menu li a:hover {
            color: #fe1100;
        }

        .has-submenu .dropdown-arrow {
            float: right;
            transform: rotate(0deg);
            transition: transform 0.3s;
        }

        /* Rotate arrow when accordion is open */
        .accordion-menu.open + a .dropdown-arrow,
        .dropdown-arrow.active {
            transform: rotate(180deg);
        }

        /* Make parent link a flex container */
        .nav ul li.has-submenu > a {
            display: flex;
            justify-content: space-between;
            align-items: center;
			width: 100%;
			flex-direction: row;
        }
    }

    /* Dropdown Arrow */
    .dropdown-arrow {
        margin-left: 5px;
        font-size: 0.6em;
        transition: transform 0.3s ease;
    }

    /* Parent Link with Submenu */
    .has-submenu {
        display: flex;
		flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        cursor: pointer;
    }

    /* Desktop Dropdown Menu */
    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        background-color: white;
        min-width: 200px;
        box-shadow: 0 8px 16px rgba(0,0,0,0.2);
        display: none;
        z-index: 1000;
    }

    .dropdown-menu.show {
        display: block;
    }

    .dropdown-menu li {
        padding: 10px;
    }

    .dropdown-menu li a {
        color: #131314;
        text-decoration: none;
        display: block;
        padding: 8px 16px;
    }

    .dropdown-menu li a:hover {
        background-color: #f1f1f1;
        color: #fe1100;
    }

    /* Accordion Menu for Mobile */
    .accordion-menu {
        display: none;
        flex-direction: column;
		width: 100%;
    }

    .accordion-menu.open {
        display: flex;
    }

    .accordion-menu li {
        padding: 5px 10px 5px 15px !important;
        // border-top: 1px solid #f3f3f3;
		width: 100%;
    }

    .accordion-menu li a {
        color: #131314;
        text-decoration: none;
        display: block;
        padding: 8px 0;
    }

    .accordion-menu li a:hover {
        color: #fe1100;
    }

    /* Additional Styles for Accessibility */
    .has-submenu:focus + .dropdown-menu,
    .has-submenu:focus-within + .dropdown-menu {
        display: block;
    }

    /* Ensure proper positioning */
    nav ul {
        position: relative;
    }

    nav ul li {
        position: relative;
    }

    /* Styling the active menu items */
    .nav ul.no-format > li.active > a {
        color: #fe1100;
    }
</style>
